import React from "react";
import { useQuery } from "react-query";
// css
import "./Dashboard.modules.css";
//pages
import InfoCards from "./InfoCards.jsx";
import ErrorMessage from "../../components/charts/ErrorMessage.jsx";
//services
import { getGraphics } from "../../services/Dashboard/getGraphics.js";
import { Skeleton } from "primereact/skeleton";
// charts
import DonnutChart from "../../components/charts/DonnutChart.js";
import LineChart from "../../components/charts/LineChartSales.js";
import PieChartLand from "../../components/charts/PieChartLand.js";
import DonnutChartTeam from "../../components/charts/DonnutChartTeam.js";
import ColumnChartBill from "../../components/charts/ColumnChartBill.js";
import ColumnChartLand from "../../components/charts/ColumnChartLand.js";
import ColumnChartAccount from "../../components/charts/ColumnChartAccount.js";
import BarChartInfringement from "../../components/charts/BarChartInfringement.js";
//context
import { useAppContext } from "../../context/AppContext.jsx";
import usePermission from "../../hooks/usePermission.jsx";
import LineChartPayments from "../../components/charts/LineChartPayments.js";

export default function Dashboard() {
  const { permissions, nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  usePermission("5"); //Visualizar Dashboard

  const {
    data: dataSales,
    isLoading: isLoadingSales,
    isError,
  } = useQuery("dataSales", () => getGraphics("sale"), {
    manual: true,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!permissions?.includes("5"),
  });

  const { data: dataPaid, isLoading: isLoadingPaid } = useQuery(
    "dataPaid",
    () => getGraphics("future_paid"),
    {
      manual: true,
      staleTime: 60000,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!permissions?.includes("5"),
    }
  );

  const { data: dataNonPay, isLoading: isLoadingNonPay } = useQuery(
    "dataNonPay",
    () => getGraphics("non_payment"),
    {
      manual: true,
      staleTime: 60000,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!permissions?.includes("5"),
    }
  );

  const {
    data: dataLandStatus,
    isLoading: isLoadingLandStatus,
    isError: errorLandStatus,
  } = useQuery("dataLandStatus", () => getGraphics("lands_status"), {
    manual: true,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!permissions?.includes("5"),
  });

  const {
    data: dataLandPercentage,
    isLoading: isLoadingLandPercentage,
    isError: errorLandPercentage,
  } = useQuery("dataLandPercentage", () => getGraphics("lands_percentage"), {
    manual: true,
    staleTime: 60000,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!permissions?.includes("5"),
  });

  const { data: dataBilletMonthly, isLoading: isLoadingBilletMonthly } =
    useQuery("dataBilletMonthly", () => getGraphics("billet_monthly"), {
      manual: true,
      staleTime: 60000,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!permissions?.includes("5"),
    });

  const {
    data: dataTeamSales,
    isLoading: isLoadingTeamSales,
    isError: errorTeamSales,
  } = useQuery("dataTeamSales", () => getGraphics("team_sales"), {
    manual: true,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!permissions?.includes("5"),
  });

  const { data: dataLandValue, isLoading: isLoadingLandValue } = useQuery(
    "dataLandValue",
    () => getGraphics("lands_value"),
    {
      manual: true,
      staleTime: 60000,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!permissions?.includes("5"),
    }
  );

  return (
    <>
      <div className="row">
        <InfoCards />
      </div>
      <div className="row p-3 mx-0 bg-white rounded">
        <div className="col-md-6 px-4 mt-2 rounded">
          <h4>Quadro Geral de Vendas</h4>
          {isLoadingSales ? (
            <div className="d-flex align-items-center justify-content-center">
              <Skeleton width="100%" height="220px"></Skeleton>
            </div>
          ) : (
            <LineChart data={dataSales} />
          )}
          {isError && <p>Ocorreu um erro</p>}
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="titleChart pt-2 ">
            <h4 className="">
              Disponibilidade de{" "}
              {nomenclature ? nomenclature[1].value : "Lotes"}
            </h4>
          </div>
          {isLoadingLandStatus && (
            <div className="d-flex align-items-center justify-content-center">
              <Skeleton width="100%" height="220px"></Skeleton>
            </div>
          )}
          {errorLandStatus && <ErrorMessage />}
          {!isLoadingLandStatus && !errorLandStatus && (
            <DonnutChart data={dataLandStatus} />
          )}
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="titleChart pt-2 ">
            <h4 className="">
              % de {nomenclature ? nomenclature[1].value : "Lotes"} disponíveis
            </h4>
          </div>
          {isLoadingLandPercentage && (
            <div className="d-flex align-items-center justify-content-center">
              <Skeleton width="100%" height="220px"></Skeleton>
            </div>
          )}
          {errorLandPercentage && <ErrorMessage />}
          {!isLoadingLandPercentage && !errorLandPercentage && (
            <PieChartLand data={dataLandPercentage} />
          )}
        </div>
      </div>
      <div className="row p-3 mx-0 bg-white rounded mt-3">
        <div className="col-xl-6 p-2 text-start rounded">
          <h4>Inadimplência Geral</h4>
          {isLoadingNonPay ? (
            <div className="d-flex align-items-center justify-content-center">
              <Skeleton width="100%" height="220px"></Skeleton>
            </div>
          ) : (
            <BarChartInfringement data={dataNonPay} />
          )}
        </div>
        <div className="col-md-6 px-4 mt-2 rounded">
          <h4>Pago x Em Aberto</h4>
          {isLoadingPaid ? (
            <div className="d-flex align-items-center justify-content-center">
              <Skeleton width="100%" height="220px"></Skeleton>
            </div>
          ) : (
            <LineChartPayments data={dataPaid} />
          )}
        </div>
      </div>
      <div className="row row p-3 mx-0 bg-white rounded mt-3">
        <div className="col-xl-6 px-4 mt-2 rounded">
          <h4>Parcelas Mensais</h4>
          {isLoadingBilletMonthly ? (
            <div className="d-flex align-items-center justify-content-center">
              <Skeleton width="100%" height="220px"></Skeleton>
            </div>
          ) : (
            <ColumnChartBill data={dataBilletMonthly} />
          )}
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="titleChart pt-2 ">
            <h4 className="">Vendas por equipe</h4>
          </div>
          {isLoadingTeamSales && (
            <div className="d-flex align-items-center justify-content-center">
              <Skeleton width="100%" height="220px"></Skeleton>
            </div>
          )}
          {errorTeamSales && <ErrorMessage />}
          {!isLoadingTeamSales && !errorTeamSales && (
            <DonnutChartTeam data={dataTeamSales} />
          )}
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="titleChart pt-2 ">
            <h4 className="">
              Valor {nomenclature ? nomenclature[1].value : "Lotes"} Geral
            </h4>
          </div>
          {isLoadingLandValue ? (
            <div className="d-flex align-items-center justify-content-center">
              <Skeleton width="100%" height="220px"></Skeleton>
            </div>
          ) : (
            <ColumnChartLand data={dataLandValue} />
          )}
        </div>
      </div>
    </>
  );
}
